<!--suppress HtmlUnknownBooleanAttribute, AngularUndefinedBinding -->
<div class="row">
  <div class="col-12 col-md-10">
    <nav class="breadcrumb-one" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="javascript:void(0);">
            <svg class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
          </a>
        </li>
        <li class="breadcrumb-item">
          <a [routerLink]="'/private/affiliate'" translate>Affiliate Marketing</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page" translate>Affiliate Merchants</li>
      </ol>
    </nav>
  </div>
</div>

<div [hidden]="loading" class="col-xl-12 col-lg-12 col-sm-12 layout-spacing">
  <div class="widget-content widget-content-area br-6">
    <div class="table-responsive mb-4 mt-4">
      <table id="multi-column-ordering" class="table table-hover" style="width:100%">
        <thead>
        <tr>
          <th translate>ID</th>
          <th translate>Shop Name</th>
          <th translate>VAT Number</th>
          <th translate>License Name</th>
          <th translate>License Type</th>
          <th translate>Phone</th>
          <th translate>Email</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngIf="merchants == null || merchants.length == 0">
          <td colspan="8" style="text-align: center; font-size: 12pt; color: cadetblue">
            {{ 'No merchants found' | translate }}
          </td>
        </tr>
        <tr *ngFor="let merchant of merchants">
          <!-- ID -->
          <td>
            <span>{{ merchant.id }}</span>
          </td>
          <!-- Shop Name -->
          <td>
            <span>{{ merchant.shopName }}</span>
          </td>
          <!-- VAT Number -->
          <td>
            <span>{{ merchant.vatNumber }}</span>
          </td>
          <!-- License Name -->
          <td>
            <span>{{ merchant.licenseName }}</span>
          </td>
          <!-- License Type -->
          <td>
            <span>{{ merchant.licenseType }}</span>
          </td>
          <!-- Phone -->
          <td>
            <span>{{ merchant.phone }}</span>
          </td>
          <!-- Email -->
          <td>
            <span>{{ merchant.email }}</span>
          </td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <th translate>ID</th>
          <th translate>Shop Name</th>
          <th translate>VAT Number</th>
          <th translate>License Name</th>
          <th translate>License Type</th>
          <th translate>Phone</th>
          <th translate>Email</th>
        </tr>
        </tfoot>
      </table>
    </div>
    <div class="row mb-4">
      <div class="col-12">
        <button class="btn btn-primary" [routerLink]="'/private/affiliate'" translate>Back</button>
      </div>
    </div>
  </div>
</div>
<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>
